import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { CSpinner } from "@coreui/react";
import CameraDetailPage from "./CameraDetailPage";
import TruckDetailPage from "./TruckDetailPage";
import GarbageTruckDetailPage from "./GarbageTruckDetailPage";
import RoadMarkingDetailPage from "./RoadMarkingDetailPage";

// Тип техники - по идентификатору (VehicleType.identifier), а не по pk: pk на проде и на копии
// разные (самосвал 3 и 5), и pk 5 на копии совпадал с прежней константой мусоровоза.
// Идентификатор берется из ответа /api/devices/<id>/: vehicle_type.identifier (если тип вложен
// объектом) или vehicle_type_identifier. Если его нет - по названию типа, как раньше.
const TRUCK_TYPE_IDENTIFIER = "TR";
const ROAD_MARKING_IDENTIFIER = "RAZM";
// У мусоровоза своего VehicleType нет (IMU-пайплайн его не обрабатывает) - он определяется по названию

const DeviceDetailPage = () => {
  const { cameraId } = useParams();
  const [deviceInfo, setDeviceInfo] = useState(undefined);

  useEffect(() => {
    let cancelled = false;
    const token = localStorage.getItem("token");

    axios
      .get(`/api/devices/${cameraId}/`, { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => {
        if (cancelled) return;
        const rawType = res.data.vehicle_type;
        const typeIdentifier =
          (rawType && typeof rawType === "object" ? rawType.identifier : null) ||
          res.data.vehicle_type_identifier ||
          "";
        const typeName = (
          res.data.vehicle_type_name ||
          (rawType && typeof rawType === "object" ? rawType.type_str : "") ||
          ""
        ).toLowerCase();

        setDeviceInfo({
          identifier: String(typeIdentifier).trim().toUpperCase(),
          name: typeName,
        });
      })
      .catch(() => {
        if (!cancelled) setDeviceInfo(null);
      });

    return () => {
      cancelled = true;
    };
  }, [cameraId]);

  if (deviceInfo === undefined) {
    return (
      <div className="text-center p-5">
        <CSpinner />
      </div>
    );
  }

  const isTruck = deviceInfo?.identifier
    ? deviceInfo.identifier === TRUCK_TYPE_IDENTIFIER
    : deviceInfo?.name?.includes("самосвал") || deviceInfo?.name?.includes("truck");

  if (isTruck) {
    return <TruckDetailPage />;
  }

  const isRoadMarking =
    deviceInfo?.identifier === ROAD_MARKING_IDENTIFIER ||
    deviceInfo?.name?.includes("дорожная разметка") ||
    deviceInfo?.name?.includes("разметк");

  if (isRoadMarking) {
    return <RoadMarkingDetailPage />;
  }
  

  const isGarbageTruck =
    deviceInfo?.name?.includes("мусоровоз") ||
    deviceInfo?.name?.includes("garbage");

  if (isGarbageTruck) {
    return <GarbageTruckDetailPage />;
  }

  return <CameraDetailPage />;
};

export default DeviceDetailPage;